import { Button } from "@workspace/ui/components/button";
import {
  Building2,
  Clock,
  Database,
  ListChecks,
  Sparkles,
  Users,
} from "lucide-react";
import Link from "next/link";
import { Feature, type FeatureItem } from "./feature";

const features: FeatureItem[] = [
  {
    title: "AI-based candidate matching",
    description:
      "Connect with qualified candidates using our advanced AI algorithms that match your specific requirements.",
    icon: <Users className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "In-depth & flexible vetting",
    description:
      "Choose from a comprehensive range of verification checks to ensure candidates meet your specific job requirements.",
    icon: <Clock className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "Pre-screen candidates using AI",
    description:
      "Leverage AI assistance to efficiently pre-screen and evaluate candidates, saving time while ensuring quality matches.",
    icon: <Sparkles className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "Applicant tracking",
    description:
      "Rank applicants, create shortlists, and seamlessly select the best candidates for interviews with our intuitive tracking system.",
    icon: <ListChecks className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "Source candidates from local talent pool",
    description:
      "Access our extensive local talent database and proactively search for the perfect candidates to match your hiring needs.",
    icon: <Database className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "Recruitment assist",
    description:
      "Tell us what talent you need and how many - we'll take care of the rest for you.",
    icon: <Building2 className="h-5 w-5 md:h-6 md:w-6" />,
  },
];

export function EmployersFeaturesSection() {
  return (
    <section
      className="border-border/50 border-t bg-muted/20 py-16 md:py-20 lg:py-24"
      id="employers"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            For employers
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            Connect with qualified candidates and streamline your hiring process
            with our powerful recruitment tools.
          </p>
        </div>

        <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 py-6 sm:grid-cols-2 md:py-10 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Feature
              {...feature}
              index={index}
              key={feature.title}
              totalFeatures={features.length}
            />
          ))}
        </div>

        <div className="mt-8 text-center md:mt-12">
          <Button asChild size="lg">
            <Link href="/jobs?modal=create-job">Post a job</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
